import React, { Dispatch, SetStateAction } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { Scalars } from "../../types/graphql";
import {
  IStructuredHeaderLinksData,
  PureHeaderLinks,
} from "./pure-header-links";
import { useMergePrismicPreviewData } from "gatsby-plugin-prismic-previews";
interface IHeaderLinksProps {
  headerLinksUID: string;
  setHeaderLinksData: (data: IStructuredHeaderLinksData) => void;
  isHeaderLinksDataSet: boolean;
  isOpen: boolean;
  showAnnouncementBanner: boolean;
}

const query = graphql`
  query HeaderLinks {
    allPrismicHeaderLinks {
      edges {
        node {
          ...HeaderLinksNode
        }
      }
    }
  }
`;

// Render function for Header Links, queries Prismic for data in
// a static query and renders the PureHeaderLinks component.
export default function RenderHeaderLinks(props: IHeaderLinksProps) {
  const staticData = useStaticQuery(query);

  return (
    <PureHeaderLinks
      headerLinks={useMergePrismicPreviewData(staticData)}
      headerLinksUID={props.headerLinksUID}
      setHeaderLinksData={props.setHeaderLinksData}
      isHeaderLinksDataSet={props.isHeaderLinksDataSet}
      isOpen={props.isOpen}
      showAnnouncementBanner={props.showAnnouncementBanner}
    />
  );
}
